<div *ifSize="'XL'"
     class="_left-section bg-col-5">
    <scrollable>
        <ng-container *ngTemplateOutlet="sectionOptionTpl"></ng-container>
    </scrollable>

</div>

<!-- main image -->
<builder-gallery [storageData]="storageData"
                 [background]="content.backgroundImage"
                 [horseImageData]="horseImageData"
                 [riderImageData]="riderImageData"
                 [basePosition]="baseGalleryPosition"
                 [hideImageOnToggle]="hideImageOnToggle"
                 [currentOpenedOption]="currentOption"
                 [displayAltImage]="displayAltImage">
    <!-- tools -->
    <div topTools
         class="w-12 inline-flex">
        <button class="_round-button box-shadow-1 bg-col-w col-12 b-radius-max inline-flex"
                (click)="undo()"><i class="icon-return _icon inline-flex"></i>
            @if (!app.client.isTouchy) {
            <tooltip [position]="'bottom'">{{'Undo' | translate}}</tooltip>
            }
        </button>
        @if (canShowToogle) {
        <div class="pos-relative">
            <div class="m-l-2 _toggle box-shadow-1 b-a b-col-5 bg-col-5">
                @for (option of toggleOptions; track option.value) {
                <p class="_element center p2"
                   [class._active]="toggleState === option.value"
                   (click)="changeToggleState(option.value)">{{option.label | translate}}</p>
                }
            </div>
            @if (displayNewLabelForToggle) {
            <div class="_toggleNewLabel ">
                <div class="p-t-1 p-b-1 p-l-2 p-r-2 b-a b-col-1 pos-relative _toggleLabelArrow">
                    <p class="p3">{{'New!' | translate}}</p>
                </div>

            </div>
            }
        </div>
        }

        <div class="flex-grow"></div>

        <button class="_round-button box-shadow-1 bg-col-5 col-1 b-radius-max inline-flex"
                (click)="reset()"><span class="p2 p-r-2 p-l-2">{{'Reset' | translate}}</span>
            @if (!app.client.isTouchy) {
            <tooltip [position]="'bottom'">{{'Start over' | translate}}</tooltip>
            }
        </button>
    </div>
    <div wishlist
         class="pos-absolute inline-flex z-2"
         sizeClass="SM: bottom-2 left-2, XL: bottom-4 left-4">
        <button class="_round-button box-shadow-1 bg-col-w col-12 b-radius-max inline-flex m-r-2"
                (click)="addToWishlist()">
            <i class="_icon inline-flex"
               [ngClass]="showWishlistStatus.busy ? 'icon-loading' : 'icon-wishlist'"></i>
            @if (!app.client.isTouchy) {
            <tooltip [position]="'top'">{{'Save' | translate}}</tooltip>
            }
            <tooltip [position]="'top-right'"
                     [ngStyle]="{'opacity': showWishlistStatus.success ? 1 : 0}">{{'Products added to wishlist!' |
                translate}}
            </tooltip>
        </button>
        <button class="_round-button box-shadow-1 bg-col-w col-12 b-radius-max inline-flex"
                [ga4TrackClick]="{name: 'ob_share_link_interaction', details: { shareMethod: 'copy_link' }}"
                [ga4TrackClickOff]="!useGA4"
                (click)="copyUrlToClipboard()"><i [ngClass]="copyStatus.busy ? 'icon-loading' : 'icon-share-1'"
               class="_icon inline-flex"></i>
            @if (!app.client.isTouchy) {
            <tooltip [position]="'top'">{{'Share' | translate}}</tooltip>
            }
            <tooltip [position]="'top-right'"
                     [ngStyle]="{'opacity': showCopyNotification ? 1 : 0}">{{'Link copied to clipboard!' | translate}}
            </tooltip>
        </button>
    </div>

    <!-- Add to basket -->
    <div addToBasket
         *ifSize="'XL'"
         class="pos-absolute bg-col-w z-2 p-a-2 p-r-3 p-l-3 inline-flex flex-middle box-shadow-1 bottom-4 right-4"
         style="border-radius: 2px;">
        <p class="m-r-10">
            <span class="col-11 p2 m-r-1">{{'Total:' | translate}}</span>
            <price class="s2"
                   [value]="totalPrice || 0"></price>
        </p>
        <builder-add-to-basket [isDisabled]="!basketRequest?.length"
                               [basketRequest]="basketRequest"
                               [content]="content"
                               [storageData]="storageData"></builder-add-to-basket>
    </div>
</builder-gallery>


<div *ifSize="'SM'"
     class="_left-section bg-col-5 overflow-visible no-wrap"
     [elementHeight]="'builder-attr-section'">
    <ng-container *ngTemplateOutlet="sectionOptionTpl"></ng-container>
</div>

<!-- listing -->
<div class="_right-tab overflow-hidden z-2"
     [sizeClass]="'SM: flex-grow, XL: box-shadow-1'"
     [class._bottomSpace]="app.client.sizeId < 2 && basketRequest?.length">
    <div class="flex-column height-100">
        <!-- additional horse step -->
        @if(storageData.currentSectionOptionId === additionalHorseStep.id) {
        <div class="p-a h3 w-12 b-b b-col-4"
             [sizeClass]="'XL: p-t-5 p-b-5'"
             [style.min-height.px]="65">{{additionalHorseStep.title | translate}}</div>

        <div class="_grid flex-grow custom-scrollbar">
            <div class="p-a"
                 [grid]="app.client.isS ? 2 : 3"
                 [gridRowGap]="4"
                 [gridColumnGap]="2">
                @for(option of additionalHorseStep.options; track $index) {
                <div style="width: auto"
                     [gridColumn]="1"
                     [gridRowSpan]="1"
                     class="cursor-pointer"
                     (click)="selectAdditionalOption(option.name)">
                    <div [ngClass]="additionalHorseStep.squareVariant ? 'ratio-1-1' : 'ratio-3-2'"
                         [class._selectedAdditional]="isSelectedAdditionalOption(option.name)">
                        <img class="fill"
                             [image]="option.image"
                             [options]="{fitIn: true, fillColor: 'transparent'}">
                    </div>
                    <p class="p2 m-t-1 center">{{option.name}}</p>
                </div>
                }
            </div>
        </div>

        } @else {
        <!-- usual listing with products -->
        @if (currentOption?.listing) {
        <builder-listing-tools class="w-12 b-b b-col-4 p-a p-t-3-s p-t-3-m p-b-3-s p-b-3-m"
                               [listing]="currentOption.listing"
                               [title]="currentOption.listingTitle || getSectionOptionLabel(currentOption.sectionOption)"></builder-listing-tools>
        }

        <div #gridContainer
             class="_grid flex-grow custom-scrollbar">
            @if (currentOption) {
            <div class="p-a"
                 [grid]="app.client.isS ? 2 : 3"
                 [gridRowGap]="app.client.isS ? 2 : 4"
                 [gridColumnGap]="4">
                @for (product of getProducts(); track $index; let index = $index) {
                <div class="pos-relative"
                     style="width: auto"
                     [gridColumn]="1"
                     [gridRowSpan]="1">
                    <!--  [gtmTrackProductClick]="{productId: model.id, position: i+1, list: context === 'search' ? 'Search results' : ''}" -->
                    <builder-product [model]="product"
                                     [gtmImpressionTrack]="getGtmImpressionData(product, index, currentOption.listing.models.length)"
                                     [gtmTrackProductClick]="getGtmTrackData(product, index)"
                                     (click)="openProductPreview(product)"
                                     class="block cursor-pointer"
                                     [class._selected-product]="isSelectedProduct(product)">
                    </builder-product>
                    @if (clickedProductId === product.id && clickedProductStatus.busy) {
                    <div class="_loadingProduct">
                        <i class="icon-loading _icon"></i>
                    </div>
                    }
                    <!-- remove -->
                    <div class="pos-absolute top-1 right-1 pe-none">
                        @if (isSelectedProduct(product)) {
                        <button class="_remove-product bg-col-1 pe-auto inline-flex"
                                (click)="unselectCurrentOption()">
                            <i class="icon-close _icon inline-flex col-w"></i>
                        </button>
                        }
                    </div>
                </div>
                }
            </div>
            }
        </div>
        }
    </div>
</div>

<ng-container *ifSize="'SM'">
    @if (basketRequest?.length) {
    <div [elementHeight]="'builder-add-to-basket'"
         class="bg-col-w z-2 p-a inline-flex flex-middle box-shadow-1 w-12 pos-fixed bottom-0 left-0">
        <p class="w-6 p-r-1">
            <span class="col-1 p1 m-r-1">{{'Total:' | translate}}</span>
            <price class="s1"
                   [value]="totalPrice || 0"></price>
        </p>
        <builder-add-to-basket class="block w-6 p-l-1"
                               [isDisabled]="!basketRequest?.length"
                               [basketRequest]="basketRequest"
                               [content]="content"
                               [storageData]="storageData"></builder-add-to-basket>
    </div>
    }
</ng-container>

<ng-template #sectionOptionTpl>
    @if(additionalHorseStep && isAdditionalStepState) {
    <div class="w-12 ratio-1-1 col-12 _option"
         [class._active]="storageData.currentSectionOptionId === additionalHorseStep.id"
         [class._approved]="true"
         (click)="changeCurrentOption(additionalHorseStep.id)">
        <img [image]="additionalHorseStep.image"
             class="rf _icon">
        <i class="icon-tick pos-absolute top-1 right-1 bg-col-3 col-w _tick inline-flex b-radius-max"></i>
        @if (!app.client.isTouchy) {
        <tooltip [position]="'right'">{{additionalHorseStep.title | translate}}</tooltip>
        }
    </div>
    }
    @for (option of leftSectionOption; track $index) {
    <div class="w-12 ratio-1-1 col-12 _option"
         [class._active]="storageData.currentSectionOptionId === option.sectionOption"
         [class._approved]="isSectionOptionSelected(option.sectionOption)"
         (click)="changeCurrentOption(option.sectionOption)">
        <img [image]="option.iconImage"
             class="rf _icon">
        <i class="icon-tick pos-absolute top-1 right-1 bg-col-3 col-w _tick inline-flex b-radius-max"></i>
        @if (!app.client.isTouchy) {
        <tooltip [position]="'right'">{{getSectionOptionLabel(option.sectionOption)}}</tooltip>
        }
    </div>
    }
</ng-template>
